<template>
  <div>
    <div v-if="loading">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-show="!loading">
      <div class="w-full">
        <div
          slot="no-body"
          class="tabs-container inventory_tabSec"
          id="view-customer-tab"
        >
          <vs-tabs
            alignment="fixed"
            v-model="activeTab"
            class="tab-action-btn-fill-conatiner"
          >
            <vs-tab :label="$t('customers.label.Plan')">
              <Plan
                :mode="mode"
                @setPlanData="setUpdatedStatus"
                @completed="planCreated"
              />
            </vs-tab>
            <vs-tab :label="$t('customers.label.price')">
              <Pricing
                :mode="mode"
                :planVersion="planVersion"
                :planStatus="selectedStatus"
                @completed="activeTab += 1"
                :planId="id"
                :routeId="$route.params.id"
              />
            </vs-tab>
            <vs-tab :label="$t('setup.label.Discount')">
              <PlanDiscountMapping
                :planId="id"
                :routeId="$route.params.id"
                :planName="planName"
                :planVersion="planVersion"
                :planStatus="selectedStatus"
                :mode="mode"
                @completed="activeTab += 1"
              />
            </vs-tab>
            <vs-tab :label="$t('setup.label.Promotion')">
              <PlanPromotionMapping
                :planId="id"
                :routeId="$route.params.id"
                :planName="planName"
                :planVersion="planVersion"
                :planStatus="selectedStatus"
                :mode="mode"
                @completed="activeTab += 1"
              />
            </vs-tab>
            <vs-tab :label="$t('customers.label.digital_content')">
              <DigitalContent
                :planId="id"
                :planVersion="planVersion"
                :planStatus="selectedStatus"
                :mode="mode"
                @completed="activeTab += 1"
              />
            </vs-tab>
            <vs-tab :label="$t('setup.label.validation_rule')">
              <PlanValidationRule
                :planId="id"
                :routeId="$route.params.id"
                :planName="planName"
                :planVersion="planVersion"
                :planStatus="selectedStatus"
                :mode="mode"
                @completed="activeTab += 1"
              />
            </vs-tab>
          </vs-tabs>
        </div>

        <validation-popup
          :errorMessage="errorMessage"
          :warningPopup="warningPopup"
          :warningText="warningText"
          @closeWarning="warningPopup = false"
        ></validation-popup>
      </div>
      <div
        class="w-full flex items-center justify-center gap-3"
        v-if="routedFrom == 'approval'"
      >
        <vs-button class="mr-3 footerButton-next" @click="openApprovePopup">{{
          $t("admin.label.Approve")
        }}</vs-button>
        <vs-button class="mr-3 footerButton-next" color="red" @click="openRejectPopup">{{
          $t("admin.label.Reject")
        }}</vs-button>
      </div>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('admin.label.Reject')"
          :active.sync="rejectPopup"
          class="popup-close mid-popup"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col w-full mb-6">
                <small class="date-label">{{ $t("admin.label.Comment") }}</small>
                <vs-textarea v-model="checkerComment" />
              </div>
            </div>
            <div class="error">
              {{ errorMessage }}
            </div>
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="onApprovalAction('reject')"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.confirm") }}</vs-button
                >
              </span>
            </div>
            <div style="height: 20px"></div>
          </form>
        </vs-popup>
      </div>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('admin.label.Approve')"
          :active.sync="approvePopup"
          class="popup-close mid-popup"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col w-full mb-6">
                <small class="date-label">{{ $t("admin.label.Comment") }}</small>
                <vs-textarea v-model="checkerComment" />
              </div>
            </div>
            <div class="error">
              {{ errorMessage }}
            </div>
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="onApprovalAction('approve')"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.confirm") }}</vs-button
                >
              </span>
            </div>
            <div style="height: 20px"></div>
          </form>
        </vs-popup>
      </div>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('admin.label.Approve')"
          :active.sync="approvePopup"
          class="popup-close mid-popup"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col w-full mb-6">
                <small class="date-label">{{ $t("admin.label.Comment") }}</small>
                <vs-textarea v-model="approvalComment" />
              </div>
            </div>
            <div class="error">
              {{ errorMessage }}
            </div>
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="onApprovalAction('approve')"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.confirm") }}</vs-button
                >
              </span>
            </div>
            <div style="height: 20px"></div>
          </form>
        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Multiselect from "vue-multiselect";
import vSelect from "vue-select";
import { AtomSpinner } from "epic-spinners";
import { VueEditor } from "vue2-editor";
import TreeNode from "@/components/treeView.vue";
import PlanDiscountMapping from "./planDiscountMapping.vue";
import PlanValidationRule from "./validationRule.vue";
import PlanPromotionMapping from "./planPromotionMapping.vue";
import DigitalContent from "@/views/setup/PlanPricing/PlanContent.vue";
import Plan from "./Plan.vue";
import Pricing from "./Pricing.vue";

export default {
  props: {
    mode: String,
  },
  components: {
    FormWizard,
    TabContent,
    ValidationProvider,
    ValidationObserver,
    Datepicker,
    "v-select": vSelect,
    Multiselect,
    AtomSpinner,
    VueEditor,
    TreeNode,
    PlanDiscountMapping,
    PlanValidationRule,
    PlanPromotionMapping,
    DigitalContent,
    Plan,
    Pricing,
  },
  data() {
    return {
      planType: "",
      activeTab: 0,
      selectedStatusId: 0,
      locale: "en",
      dateFormat: "dd MMMM yyyy HH:mm:ss",
      endDate: "",
      billType: ["Advance", "Arrear"],
      selectedBillFrequency: [],
      selectedDurations: [],
      serviceId: "",
      billTypes: "Arrear",
      billfrequency: "",
      durations: "",
      isAdvance: false,
      isPrepaid: false,
      products: [],
      status: "DRAFT",
      billRule: "",
      currencyId: "",
      externalPlanId: "",
      externalPlanName: "",
      duration: "",
      planCode: "",
      planDescription: "",
      units: 0,
      volume: "None",
      provisioingSystem: "None",
      startDate: moment().format("dd MMMM yyyy"),
      rejectPopup: false,
      approvePopup: false,
      checkerComment: "",
      approvalComment: "",
      //
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      // plan: planEmptyObj,
      planTypes: ["Pay", "FTA"],
      broadcasters: [],
      planCategorys: [],
      serviceData: "",
      serviceCode: "",
      addedProducts: [{ product: null, externalId: null }],
      productsShow: false,
      selected: "",
      isProvision: true,
      availableproductsX: [],
      availableproducts: [],
      availableChannels: [],
      services: [],
      selectedProducts: [],
      selectedUserIds: [],
      id: "",
      check: 0,
      allDiscounts: [],
      serviceObject: {},
      productsOfService: [],
      selectedProduct: "",
      selectedDiscount: "",
      addedDiscounts: [],
      selectedExternalProductId: "",
      planAttributes: [],

      //
      selectedRuleType: "",
      plansByRule: {},
      selectedSourcePlan: null,
      selectedTargetPlan: null,
      name: "",
      selectedAttribute: [],
      enabledOptions: [true, false],
      enabled: false,
      userChangePassword: false,
      bulkUploads: {
        file: null,
      },
      //price
      editPriceArray: [],
      chargeOwners: [
        { name: "Self", value: "self" },
        { name: "Parent", value: "parent" },
      ],
      chargeCodeOptions: null,
      durationOptions: null,
      prepaid: false,
      currencyCode: "",
      roundingTypes: ["RoundingUp", "RoundingDown", "RoundingHalf", "RoundingNearest"],
      productTypeId: 0,
      chargeCode: "",
      chargeOwner: "",
      chargevariant: "",
      discountId: "",
      price: "",
      sellingPrice: "",
      priceregion: "",
      productId: "",
      roundingType: "",
      GLID: "",
      planPrice: "",
      isPriceUpdated: true,
      discountPopup: false,
      currentProductObj: {},
      currentProductIndex: "",
      type: "NONE",
      //content
      loading: false,
      editContentPopup: false,
      createContentPopup: false,
      viewContentPopup: false,
      deleteContentPopup: false,
      selectLanguagePopup: false,
      contentUploadPopup: false,
      editData: {
        planId: "",
        text: "",
        type: "",
        locale: "",
        docId: "",
      },
      file: "",
      content: "",
      selectedLanguage: "",
      selectedNewLanguage: "",
      selectedNewType: "",
      selectedType: null,
      treeSelectedLanguage: null,
      treeContentType: null,
      dataToDelete: null,
      customToolbar: [["link", "image", "video"]],
      selectedContentTagValue: "",
      selectedContentTag: "",
      visitedTabs: new Set(),
      sourcePlanSearch: "",
      targetPlanSearch: "",
      routedFrom: "",
      approvalId: "",
      selectedStatus: "",
      planVersion: "",
      planName: "",
    };
  },
  methods: {
    planCreated(id) {
      if (id) this.id = id;
      this.activeTab += 1;
    },
    openRejectPopup() {
      this.rejectPopup = true;
    },
    openApprovePopup() {
      this.approvePopup = true;
    },
    async makerCheckerApproval() {
      try {
        this.$swal({
          title: "Do you want to send approval request?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await this.sendApproval();
              this.$router.push(`/setup/plan-pricing`);
            } catch (error) {
              this.$toasted.error("something went wrong!!");
            }
          }
        });
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async sendApproval() {
      try {
        await this.$store.dispatch("planPrice/sendApprovalAction", this.id);
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Approval request sent!",
          type: "success",
        });
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async onApprovalAction(action) {
      try {
        const payload = {
          id: this.approvalId,
          action,
          data: {},
        };
        if (action == "reject") {
          payload.data.checkerComment = this.checkerComment;
          this.rejectPopup = false;
        }
        if (action === "approve") {
          payload.data.checkerComment = this.approvalComment;
          this.approvePopup = false;
        }
        await this.$store.dispatch("planPrice/approvalAction", payload);
        let msg = action === "approve" ? "Plan Approved" : "Plan Rejected";

        if (action === "reject") {
          this.$toasted.error(msg, {
            duration: 2000,
          });
        }
        if (action === "approve") {
          this.$toasted.success(msg, {
            duration: 2000,
          });
        }
        this.$router.push("/makerchecker/approval");
      } catch (error) {
        this.$toasted.error(error.message, {
          duration: 2000,
        });
      }
    },
    setUpdatedStatus(status, version, planName) {
      this.selectedStatus = status;
      this.planVersion = version;
      this.planName = planName;
    },
  },

  async mounted() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
    }
    this.routedFrom = this.$route.query.from || "";
    this.approvalId = this.$route.query.approvalId || "";
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (!this.id) {
      const buttons = document.querySelectorAll(".vs-tabs--li button");
      for (const b of buttons) {
        b.disabled = true;
      }
      buttons[0].disabled = false;
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.vs__selected {
  width: fit-content;
}
.multiselect__tag {
  color: rgb(48, 48, 48);
  background-color: rgba(var(--vs-primary), 0.3);
  font-size: 01rem;
}
.multiselect__tag:hover {
  background-color: rgba(var(--vs-warning), 0.3);
}
.sub-class {
  align-items: center !important;
}
.multiselect__option--disabled {
  background: purple;
  color: rgba(var(--vs-primary), 1);
  font-style: italic;
}

.multiselect__option--highlight {
  background-color: rgba(var(--vs-primary), 1);
  color: rgb(255, 255, 255);
  font-size: 0.9rem;
  height: 1rem;
}

.multiselect__content {
  background: rgb(255, 255, 255);
  color: #444;
  font-size: 0.9rem;
}
.multiselect__single {
  height: 0.8rem;
  font-size: 01rem;
  color: #444;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 0.25rem 1.625rem 0.25rem 0.625rem;
  margin-right: 0.625rem;
  line-height: 1;
  margin-bottom: 0.5rem;
}
</style>
<style lang="scss" scoped>
.w-13 {
  width: 8.5%;
  padding: 0 4px;
  max-width: 90px;
  &:last-child {
    width: 4%;
  }
}
.border-left {
  border-bottom: 1px solid rgba(var(--vs-primary), 0.3);
  div {
    &:not(:first-child) {
      border-left: 1px solid rgba(var(--vs-primary), 0.3);
    }
    &:nth-child(6) {
      border-right: 1px solid rgba(var(--vs-primary), 0.3);
    }
  }
}
.heading {
  font-weight: 600;
  font-size: 0.9rem;
  div {
    padding: 0.5rem 5px !important;
  }
}
.margin-bottom {
  width: 100%;
  border-bottom: 1px solid #777;
  margin-bottom: 20px;
}
.margin-top {
  width: 100%;
  border-top: 1px solid #777;
  margin-top: 20px;
}
</style>
<style scoped>
.version-container {
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 5px;
}
.tag {
  border: 2px solid orange;
  color: orange;
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
}
.rule-card {
  height: 300px;
  min-width: 250px;
  background-color: cornsilk;
  border: 1px solid #ede4e4;
}
.header-plan {
  margin-left: 2.5rem;
  font-weight: 600;
  font-size: large;
}
.padding-zero {
  padding-top: 0px;
}
::v-deep .vs__selected-options {
  overflow: hidden;
  width: 100px;
  font-size: 12px;
  padding: 8px 2px 2px 2px !important;
}
.price-table >>> .vs-input--input.normal {
  width: 80px;
  font-size: 12px;
}
/* ::v-deep .vs--searchable .vs__dropdown-toggle {
  height: 40px;
} */
::v-deep .vs-table-text {
  display: block;
}
::v-deep .vs__selected {
  text-wrap: nowrap;
}
.less-padding .vx-row > .vx-col {
  padding: 0 4px;
}
::v-deep .vs-table--not-data {
  display: none;
}
.swal2-popup {
  text-align: center;
}
.popup-width .vs-popup {
  width: 900px !important;
}
.popup-width .ql-snow .ql-tooltip {
  left: 10px !important;
}
.min-w-14vw {
  min-width: 14vw;
}
::v-deep .vs-tabs--ul {
  width: 100%;
}
::v-deep .vx-row > .vx-col {
  padding: 0 1rem !important;
}
@media (min-width: 1200px) {
  .xl\:w-1\/5 {
    width: 20% !important;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect__tag {
  color: rgb(48, 48, 48);
  background-color: rgba(var(--vs-primary), 0.3);
  font-size: 01rem;
}
.multiselect__tag:hover {
  background-color: rgba(var(--vs-warning), 0.3);
}

.multiselect__option--disabled {
  background: purple;
  color: rgba(var(--vs-primary), 1);
  font-style: italic;
}

.multiselect__option--highlight {
  background-color: rgba(var(--vs-primary), 1);
  color: rgb(255, 255, 255);
  font-size: 0.9rem;
  height: 1rem;
}

.multiselect__content {
  background: rgb(255, 255, 255);
  color: #444;
  font-size: 0.9rem;
}
.multiselect__single {
  height: 0.8rem;
  font-size: 01rem;
  color: #444;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 0.25rem 1.625rem 0.25rem 0.625rem;

  margin-right: 0.625rem;

  line-height: 1;

  margin-bottom: 0.5rem;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateX(2rem);
}

.Myselect .v-select .dropdown-toggle {
  border: none;
}
.sub-class {
  align-items: center !important;
}
.version-container {
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 5px;
}
.tag {
  border: 2px solid orange;
  color: orange;
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
}
.tag-approval {
  border: 2px solid rgb(14, 140, 224);
  color: rgb(23, 180, 228);
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.rule-sidebar {
  margin-top: 4rem;
}
.search-box {
  border: 1px solid #c4bfbf;
}
</style>
